import { Flex, Icon, Text } from '@chakra-ui/react';
import { RemoveRedEyeOutlined } from '@mui/icons-material';

type ViewCountProps = {
  count: number;
};

export function ViewCount({ count }: ViewCountProps) {
  return (
    <Flex alignItems="center" gap="1" color="gray.75">
      <Icon
        as={RemoveRedEyeOutlined}
        fontSize={{ base: '2xs', md: 'xs', xl: 'sm' }}
      />
      <Text fontSize={{ base: '2xs', md: 'xs', xl: 'sm' }}>{count}</Text>
    </Flex>
  );
}
